import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { HttpAdminApi } from "../../../../interface/admin-api";

interface PropsType {
  broadSeq: string;
  eventInfo: any;
  callback: any;
}

const adminApi = new HttpAdminApi();

const SelectGameForm = ({ broadSeq, eventInfo, callback }: PropsType) => {
  const [gameFlag, setGameFlag] = useState("");

  const [isFcfs, setIsFcfs] = useState(false);

  const [touched, setTouched] = useState<boolean[]>([]);
  const [quizTouched, setQuizTouched] = useState(false);

  const [ladderNum, setLadderNum] = useState(2);
  const [ladderInputs, setLadderInputs] = useState<string[]>(["", ""]);

  const [choiceQuiz, setChoiceQuiz] = useState("");
  const [choiceAnswers, setChoiceAnswers] = useState<string[]>(["", "", "", ""]);

  const [oxQuiz, setOxQuiz] = useState("");
  const [oxAnswer, setOxAnswer] = useState<"O" | "X" | null>(null);

  const [shortQuiz, setShortQuiz] = useState("");
  const [shortAnswer, setShortAnswer] = useState("");
  const [shortAnswerTouched, setShortAnswerTouched] = useState(false);

  useEffect(() => {
    setTouched([]);
    setIsFcfs(false);
    setQuizTouched(false);
    setShortAnswerTouched(false);
    setOxAnswer(null);
  }, [gameFlag]);

  useEffect(() => {
    setLadderInputs((prev) => {
      const newArr = [...prev];
      if (ladderNum > prev.length) {
        // 추가
        return [...newArr, ...Array(ladderNum - prev.length).fill("")];
      } else if (ladderNum < prev.length) {
        // 삭제
        return newArr.slice(0, ladderNum);
      }
      return prev;
    });

    setTouched((prev) => {
      if (ladderNum > prev.length) {
        // 추가 (모두 false 로 추가)
        return [...prev, ...Array(ladderNum - prev.length).fill(false)];
      } else if (ladderNum < prev.length) {
        // 삭제
        return prev.slice(0, ladderNum);
      }
      return prev;
    });
  }, [ladderNum]);

  const saveQuiz = async () => {
    if (gameFlag === "ladder") {
      const isAnyEmpty = ladderInputs.some((v) => !v.trim());

      if (isAnyEmpty) {
        setTouched((prev) => {
          const updated = [...prev];
          ladderInputs.forEach((v, i) => {
            if (!v.trim()) updated[i] = true;
          });
          return updated;
        });
        return;
      }
    } else if (gameFlag === "choice") {
      const isQuizEmpty = !choiceQuiz.trim();
      const isAnswersEmpty = choiceAnswers.some((v) => !v.trim());

      if (isQuizEmpty) {
        setQuizTouched(true);
      }

      if (isAnswersEmpty) {
        setTouched((prev) => {
          const updated = [...prev];
          choiceAnswers.forEach((v, i) => {
            if (!v.trim()) updated[i] = true;
          });
          return updated;
        });
      }

      if (isQuizEmpty || isAnswersEmpty) {
        return;
      }
    } else if (gameFlag === "oxquiz") {
      if (!oxQuiz || !oxAnswer) {
        if (!oxQuiz) setQuizTouched(true);
        return;
      }
    } else if (gameFlag === "short") {
      if (!shortQuiz || !shortAnswer) {
        if (!shortQuiz) setQuizTouched(true);
        if (!shortAnswer) setShortAnswerTouched(true);
        return;
      }
    }

    if (!window.confirm("게임을 생성하시겠습니까?")) return;

    const param = {
      command: "select_game",
      broad_seq: broadSeq,
      event_seq: eventInfo.sk,
      is_fcfs: isFcfs,
      ...(gameFlag === "ladder" && {
        is_fcfs: true,
      }),
      game_kind: gameFlag,
      game_info: {
        ...(gameFlag === "ladder" && {
          ladder_num: ladderNum,
          ladder_inputs: ladderInputs,
        }),
        ...(gameFlag === "choice" && {
          quiz: choiceQuiz,
          answer: choiceAnswers[0],
          candidate: [...choiceAnswers.slice(1)],
        }),
        ...(gameFlag === "oxquiz" && {
          quiz: oxQuiz,
          answer: oxAnswer,
        }),
        ...(gameFlag === "short" && {
          quiz: shortQuiz,
          answer: shortAnswer,
        }),
      },
    };

    console.log("param : ", param);

    const res = await adminApi.post(param);
    console.log("res : ", res);
    if (res.code === "200") {
      callback({ command: "select_game", info: eventInfo });
    }
  };

  return (
    <Stack spacing={1.5} sx={{ width: "100%" }} useFlexGap>
      <Typography fontSize="14px" fontWeight={700}>
        아래 게임 유형 선택 후 내용을 입력해주세요.
      </Typography>
      <Stack direction="row" spacing={1} useFlexGap sx={{ width: "fit-content" }}>
        <Button
          variant={gameFlag === "ladder" ? "contained" : "outlined"}
          // startIcon={<CelebrationIcon />}
          onClick={() => {
            setGameFlag(gameFlag === "ladder" ? "" : "ladder");
          }}
        >
          사다리타기
        </Button>
        <Button
          variant={gameFlag === "choice" ? "contained" : "outlined"}
          // startIcon={<CelebrationIcon />}
          onClick={() => {
            setGameFlag(gameFlag === "choice" ? "" : "choice");
          }}
        >
          4지선다
        </Button>
        <Button
          variant={gameFlag === "oxquiz" ? "contained" : "outlined"}
          // startIcon={<CelebrationIcon />}
          onClick={() => {
            setGameFlag(gameFlag === "oxquiz" ? "" : "oxquiz");
          }}
        >
          O,X퀴즈
        </Button>
        <Button
          variant={gameFlag === "short" ? "contained" : "outlined"}
          // startIcon={<CelebrationIcon />}
          onClick={() => {
            setGameFlag(gameFlag === "short" ? "" : "short");
          }}
        >
          주관식퀴즈
        </Button>
      </Stack>
      {gameFlag !== "" && (
        <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
          {gameFlag === "ladder" && (
            <>
              <TextField
                label="이름 개수(최소 2, 최대 6)"
                value={ladderNum}
                variant="outlined"
                type="number"
                size="small"
                required
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: 2,
                  max: 6,
                }}
                sx={{ width: "35%" }}
                fullWidth
                onChange={(e) => setLadderNum(Number(e.target.value))}
                onBlur={(e) => {
                  if (!e.target.value) {
                    setLadderNum(2);
                  }
                }}
              />
              <Grid container rowSpacing={1} columnSpacing={2}>
                {ladderInputs.map((value, idx) => (
                  <Grid item xs={4} key={idx}>
                    <TextField
                      label={`이름 ${idx + 1}(최대 2글자)`}
                      value={value}
                      variant="outlined"
                      size="small"
                      fullWidth
                      required
                      inputProps={{
                        maxLength: 2,
                      }}
                      error={touched[idx] && !value}
                      helperText={touched[idx] && !value ? "필수 입력입니다." : ""}
                      onChange={(e) => {
                        const newInputs = [...ladderInputs];
                        newInputs[idx] = e.target.value;
                        setLadderInputs(newInputs);
                      }}
                      onBlur={() => {
                        const t = [...touched];
                        t[idx] = true;
                        setTouched(t);
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {gameFlag === "choice" && (
            <>
              <Stack direction="row" spacing={1.5} useFlexGap sx={{ alignItems: "center" }}>
                <FormControlLabel
                  label="※ 선착순 여부"
                  labelPlacement="start"
                  control={<Checkbox checked={isFcfs} onChange={(e) => setIsFcfs(e.target.checked)} />}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "red",
                      fontWeight: 700,
                    },
                    gap: 0,
                    width: "fit-content",
                  }}
                />
                <Typography sx={{ fontWeight: 500, color: "blue", fontSize: "14px" }}>
                  미선택 시 당첨자 선정 기준은 랜덤으로 선정
                </Typography>
              </Stack>
              <TextField
                label="문제"
                value={choiceQuiz}
                variant="outlined"
                type="search"
                size="small"
                required
                InputLabelProps={{ shrink: true }}
                fullWidth
                multiline
                maxRows={5}
                error={quizTouched && !choiceQuiz}
                helperText={quizTouched && !choiceQuiz ? "필수 입력입니다." : ""}
                onChange={(e) => setChoiceQuiz(e.target.value)}
                onBlur={(e) => {
                  setQuizTouched(true);
                  if (!e.target.value) {
                    setChoiceQuiz("");
                  }
                }}
              />
              <Grid container spacing={1}>
                {choiceAnswers.map((value, idx) => (
                  <Grid item xs={3} key={idx}>
                    <TextField
                      label={idx === 0 ? "정답" : `후보 ${idx}`}
                      value={value}
                      variant="outlined"
                      size="small"
                      fullWidth
                      required
                      error={touched[idx] && !value}
                      helperText={touched[idx] && !value ? "필수 입력입니다." : ""}
                      onChange={(e) => {
                        const newInputs = [...choiceAnswers];
                        newInputs[idx] = e.target.value;
                        setChoiceAnswers(newInputs);
                      }}
                      onBlur={() => {
                        const t = [...touched];
                        t[idx] = true;
                        setTouched(t);
                      }}
                      sx={
                        idx === 0
                          ? {
                              "& .MuiInputLabel-root": {
                                color: "#00A676",
                              },

                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#00A676",
                              },

                              "& .MuiInputLabel-root.Mui-error": {
                                color: "red",
                              },

                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "#00A676",
                                },
                                "&:hover fieldset": {
                                  borderColor: "#00A676",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#00A676",
                                },

                                "&.Mui-error fieldset": {
                                  borderColor: "red",
                                },
                                "&.Mui-error:hover fieldset": {
                                  borderColor: "red",
                                },
                                "&.Mui-focused.Mui-error fieldset": {
                                  borderColor: "red",
                                },
                              },
                            }
                          : {}
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {gameFlag === "oxquiz" && (
            <>
              <Stack direction="row" spacing={1.5} useFlexGap sx={{ alignItems: "center" }}>
                <FormControlLabel
                  label="※ 선착순 여부"
                  labelPlacement="start"
                  control={<Checkbox checked={isFcfs} onChange={(e) => setIsFcfs(e.target.checked)} />}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "red",
                      fontWeight: 700,
                    },
                    gap: 0,
                    width: "fit-content",
                  }}
                />
                <Typography sx={{ fontWeight: 500, color: "blue", fontSize: "14px" }}>
                  미선택 시 당첨자 선정 기준은 랜덤으로 선정
                </Typography>
              </Stack>
              <TextField
                label="문제"
                value={oxQuiz}
                variant="outlined"
                type="search"
                size="small"
                required
                InputLabelProps={{ shrink: true }}
                fullWidth
                multiline
                maxRows={5}
                error={quizTouched && !oxQuiz}
                helperText={quizTouched && !oxQuiz ? "필수 입력입니다." : ""}
                onChange={(e) => setOxQuiz(e.target.value)}
                onBlur={(e) => {
                  setQuizTouched(true);
                  if (!e.target.value) {
                    setOxQuiz("");
                  }
                }}
              />
              <FormControl error={!oxAnswer} component="fieldset" fullWidth>
                <FormLabel
                  component="legend"
                  sx={{
                    fontWeight: 700,
                    fontSize: "14px",
                  }}
                >
                  정답 선택
                </FormLabel>

                <Stack direction="row" spacing={2} useFlexGap>
                  <Button variant={oxAnswer === "O" ? "contained" : "outlined"} onClick={() => setOxAnswer("O")}>
                    O
                  </Button>
                  <Button variant={oxAnswer === "X" ? "contained" : "outlined"} onClick={() => setOxAnswer("X")}>
                    X
                  </Button>
                </Stack>

                {!oxAnswer && <FormHelperText>필수 선택입니다.</FormHelperText>}
              </FormControl>
            </>
          )}
          {gameFlag === "short" && (
            <>
              <Stack direction="row" spacing={1.5} useFlexGap sx={{ alignItems: "center" }}>
                <FormControlLabel
                  label="※ 선착순 여부"
                  labelPlacement="start"
                  control={<Checkbox checked={isFcfs} onChange={(e) => setIsFcfs(e.target.checked)} />}
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      color: "red",
                      fontWeight: 700,
                    },
                    gap: 0,
                    width: "fit-content",
                  }}
                />
                <Typography sx={{ fontWeight: 500, color: "blue", fontSize: "14px" }}>
                  미선택 시 당첨자 선정 기준은 랜덤으로 선정
                </Typography>
              </Stack>
              <TextField
                label="문제"
                value={shortQuiz}
                variant="outlined"
                type="search"
                size="small"
                required
                InputLabelProps={{ shrink: true }}
                fullWidth
                multiline
                maxRows={5}
                error={quizTouched && !shortQuiz}
                helperText={quizTouched && !shortQuiz ? "필수 입력입니다." : ""}
                onChange={(e) => setShortQuiz(e.target.value)}
                onBlur={(e) => {
                  setQuizTouched(true);
                  if (!e.target.value) {
                    setShortQuiz("");
                  }
                }}
              />
              <TextField
                label="정답"
                value={shortAnswer}
                variant="outlined"
                type="search"
                size="small"
                required
                InputLabelProps={{ shrink: true }}
                fullWidth
                multiline
                maxRows={5}
                error={shortAnswerTouched && !shortAnswer}
                helperText={shortAnswerTouched && !shortAnswer ? "필수 입력입니다." : ""}
                onChange={(e) => setShortAnswer(e.target.value)}
                onBlur={(e) => {
                  setShortAnswerTouched(true);
                  if (!e.target.value) {
                    setShortAnswer("");
                  }
                }}
              />
            </>
          )}
          <Box sx={{ width: "100%", display: "flex" }}>
            <Button variant="contained" onClick={saveQuiz}>
              확인
            </Button>
          </Box>
        </Stack>
      )}
    </Stack>
  );
};

export default SelectGameForm;
